import styled from 'styled-components'
import colors from 'Assets/colors'
import { TICKET_STATUS_COLOR } from 'Config/constants'

export const StateCell = styled.span`
  color: ${({ state }) => TICKET_STATUS_COLOR[state] ?? colors.black};
  font-weight: 700;
`
